module.exports = __webpack_public_path__ + "img/gsb43.a1ba3022.png";